import { Mentorships as MentorshipsTable } from "../mentorships";

export function Mentorships() {
  return (
    <div>
      <h2 className="my-6 text-2xl font-bold leading-7 text-black">
        Mentorships
      </h2>

      <MentorshipsTable />
    </div>
  );
}
